<template>
  <div>
    <h4 class="mr-2 mb-2">
      {{ ship.name }}
    </h4>
    <p
      v-if="ship.description"
      class="mb-6 pb-4 font-secondary"
    >
      {{ ship.description }}
    </p>
    <BedplaceFacilities
      class="mt-4 mb-12 small"
      :facilities="ship?.facilities_highlighted?.split(',')"
    />
    <LazyMediaCarousel
      v-if="shipImages.length"
      class="h-[30vw] mb-6 mt-4 min-h-[400px] max-h-px-400"
      :slides="shipImages"
      :initial-slide="isShipPage ? 1 : 0"
      v-bind="hotelImagesMediaSliderOptions"
    />
    <div
      v-if="ship.general_html"
      class="mb-6 pt-6"
      v-html="ship.general_html"
    />
    <div
      v-if="ship.rooms?.length"
      class="mt-12 pt-4"
    >
      <div
        v-for="room in shipRooms"
        :key="room.id"
        class="mb-12"
      >
        <h4 class="mb-4 md:mb-4 pb-2">
          {{ room.name }}
        </h4>
        <LazyImagesThumbnailsCarousel
          class="mb-6"
          :images="room.images"
          only-render-visible-slides
          prevent-swiper-update
        />
      </div>
    </div>
  </div>
</template>

<script>
import hotelImagesMixin, { supplierURLs } from '@packages/media/mixins/hotel-images.mixin'

export default defineNuxtComponent({
  mixins: [hotelImagesMixin],

  props: {
    ship: {
      type: Object,
      required: true,
    },

    isShipPage: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      hotelImagesMediaSliderOptions: {
        pagination: false,
        slidesPerView: 1,
        constantDisplayNavigation: true,
        rewind: true,

        breakpoints: {
          [getTailwindBreakpointsPx().md]: {
            slidesPerView: Math.min(this.ship.images.length, 2),
          },

          [getTailwindBreakpointsPx().lg]: {
            slidesPerView: Math.min(this.ship.images.length, 3),
          },
        },
      },
    }
  },

  computed: {
    shipImages () {
      return this.ship.images.map(image => ({
        url: image.image,
        type: image.image_type,
        align: image.image_alignment,
        title: this.ship.name,
      }))
    },

    shipRooms () {
      return this.ship.rooms.map(room => ({
        ...room,
        images: room.images.map((image) => {
          const baseUrl = supplierURLs.cloudinary.replace('[PATH]', image.image_cloudinary)

          return {
            src: this.imageSize(baseUrl, this.autoImageSize()),
            type: 'cloudinary',
            path: baseUrl,
            image,
          }
        }),
      }))
    },
  },
})
</script>
